<!--
 * @Author: p_fy
 * @Date: 2019-06-22 15:10:28
 * @LastEditors: Do not edit
 * @LastEditTime: 2019-08-09 13:41:49
 * @Description: 石化云仓
 -->
<template>
  <div class="Transport-wrap">
    <section class="transport-logo">
      <img src="@/assets/img/cloud.png">
    </section>
    <div class="tab-menu-content">
      <div v-if="torageStatic" class="tab-menu">
        <router-link :to="{name:'TtorageDemandInfo'}" tag="div" class="nav-link">
          <span>仓储需求信息</span>
        </router-link>
        <div class="vertical" />
        <router-link :to="{name:'TtorageSupplyInfo'}" tag="div" class="nav-link">
          <span>仓储供给信息</span>
        </router-link>
      </div>
      <div v-else class="tab-menu">
        <router-link :to="{name:'TankDemandInfo'}" tag="div" class="nav-link">
          <span>仓储需求信息</span>
        </router-link>
        <router-link :to="{name:'TankSupplyInfo'}" tag="div" class="nav-link">
          <span>仓储供给信息</span>
        </router-link>
      </div>
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'Cloud',
  data: function() {
    return {
      torageStatic: true
    }
  },
  watch: {
    '$route'(to, from) { // 监听刷新页面
      if (to.name == 'Cloud') {
        this.$router.push({ name: 'TtorageDemandInfo' })
      }
      if (to.name == 'TtorageDemandInfo' || to.name == 'TtorageSupplyInfo') {
        this.torageStatic = true
      } else {
        this.torageStatic = false
      }
    }
  },
  created() {
    this.$router.push({ name: 'TtorageDemandInfo' })
  }
}
</script>

<style scoped lang='scss'>
  .tab-menu-content{
    box-shadow:0 2px 16px 0 rgba(0, 0, 0, 0.14);
    .tab-menu{
      width: 1200px;
      margin: 0 auto;
      display:flex;
    }
    .vertical{
      border-left: 1px solid #989898;
      margin-top: 8px;
      margin-bottom: 8px;
      opacity:0.5;
    }
    .nav-link{
      span{
        font-size: 16px;
      }
      width: 50%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      &.active{
        span{
          color: #BE2316;
          font-weight: bold;
        }
      }
    }
  }
  .Transport-wrap{
    width: 100%;
  }
  .transport-logo{
    width: 100%;
    max-height: 388px;
    overflow: hidden;
    img{
      width: 100%;
      min-width: 1200px;
    }
  }
</style>

